import api from './api';
import { sendEventLog } from './eventLog';

import { getToken, login } from './auth';
import { logError } from '../utils/logError';

export const loginUser = async (response) => {
  if (response.data?.token != '') {
    await login(response.data.token);
  }
};

export const redirectUser = async (response, creatingUser = false) => {
  const event = creatingUser ? 'signup_click_start-button' : 'login';

  try {
    await sendEventLog(event, null, getToken(), {});
  } catch {
    logError('Error sending event');
  }

  window.location.assign(response.data.callback_url)
};
